import { c as _c } from "react/compiler-runtime";
import { isVaultDataDecrypted, isVaultDataEmpty, type VaultValue } from '@onefootprint/core';
import type { DataIdentifier } from '@onefootprint/types';
import type { Transforms } from '@onefootprint/types/src/data/entity';
import type React from 'react';
import type { JSX } from 'react';
import FieldOrPlaceholder from '@/components/field-or-placeholder';
export type FieldValueProps = {
  field: Record<string, boolean | string | DataIdentifier | VaultValue | Transforms | null | undefined>;
  renderValue?: (value: VaultValue, isValueDecrypted: boolean, monospaced?: boolean) => React.ReactNode;
  monospaced?: boolean;
};
const FieldValue = t0 => {
  const $ = _c(10);
  const {
    field,
    renderValue,
    monospaced
  } = t0;
  const {
    isAutoDecrypting,
    value,
    transforms
  } = field;
  if (isVaultDataEmpty(value)) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <p className="text-body-2 text-quaternary">–</p>;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  if (!renderValue) {
    const t1 = transforms as Transforms;
    const t2 = Boolean(isAutoDecrypting);
    let t3;
    if ($[1] !== monospaced || $[2] !== t1 || $[3] !== t2 || $[4] !== value) {
      t3 = <FieldOrPlaceholder data={value} transforms={t1} isLoading={t2} monospaced={monospaced} />;
      $[1] = monospaced;
      $[2] = t1;
      $[3] = t2;
      $[4] = value;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    return t3;
  }
  let t1;
  if ($[6] !== monospaced || $[7] !== renderValue || $[8] !== value) {
    t1 = renderValue(value, isVaultDataDecrypted(value), monospaced);
    $[6] = monospaced;
    $[7] = renderValue;
    $[8] = value;
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  return t1 as JSX.Element;
};
export default FieldValue;